export const DRAW_CITY = 'DRAW_CITY';
export const RESET = 'RESET';
export const SHUFFLE_DISCARD_PILE = 'SHUFFLE_DISCARD_PILE';



// WEBPACK FOOTER //
// ./src/actions/action-types.js